import React from 'react';
import { useRecoilValue } from 'recoil';
import {
  Box,
  Card,
  Divider,
} from '@mui/material';
import { CustomTypography } from 'shared/ui/CustomTypography';
import { GlassEmptyState } from 'shared/ui/GlassEmptyState';
import { selectedStudyState } from 'features/optimization/state/studyAtoms';

const subtitleSx = {
  display: 'flex',
  alignItems: 'center',
};

const glassCardSx = {
  background: 'linear-gradient(135deg, rgba(255,255,255,0.16), rgba(255,255,255,0.06))',
  border: '1px solid rgba(255,255,255,0.24)',
  borderRadius: 2,
  boxShadow: '0 10px 24px rgba(6, 24, 44, 0.24)',
  backdropFilter: 'blur(6px)',
  WebkitBackdropFilter: 'blur(6px)',
  paddingX: 1.2,
  paddingY: 1,
};

const rowSx = {
  display: 'grid',
  gridTemplateColumns: '72px 1fr',
  gap: 0.75,
  alignItems: 'start',
  paddingY: 0.2,
};

export const OptimizationStatus: React.FC = () => {
  const selectedStudy = useRecoilValue(selectedStudyState);

  if (!selectedStudy) {
    return (
      <Box component="div" sx={{ boxSizing: 'border-box', flexGrow: 1, paddingTop: 1 }}>
        <Box component="div" sx={subtitleSx}>
          <CustomTypography>Optimization Status</CustomTypography>
        </Box>
        <Divider sx={{ my: 0.5, bgcolor: '#e1e1e1' }} />
        <GlassEmptyState message="No study selected." />
      </Box>
    );
  }

  const statusCards = [
    { label: 'Running', value: selectedStudy.running, valueColor: '#8dc2ff' },
    { label: 'Complete', value: selectedStudy.complete, valueColor: '#b5f5cc' },
    { label: 'Pruned', value: selectedStudy.pruned, valueColor: '#ffd59f' },
    { label: 'Failed', value: selectedStudy.failed, valueColor: '#ffc9c9' },
  ];

  return (
    <Box component="div" sx={{ boxSizing: 'border-box', flexGrow: 1, paddingTop: 1 }}>
      <Box component="div" sx={subtitleSx}>
        <CustomTypography >Optimization Status</CustomTypography>
      </Box>

      <Divider sx={{ my: 0.5, bgcolor: '#e1e1e1' }} />

      <Box
        component="div"
        sx={{
          display: 'grid',
          gap: 0.75,
          gridTemplateColumns: { xs: '1fr', md: 'repeat(auto-fit, minmax(260px, 1fr))' },
          paddingBottom: 0.5,
        }}
      >
        {statusCards.map((item) => (
          <Card key={item.label} sx={glassCardSx}>
            <Box component="div" sx={rowSx}>
              <CustomTypography sx={{ color: '#b5c7ef' }}>Type</CustomTypography>
              <CustomTypography sx={{ color: '#f5f8ff' }}>{item.label}</CustomTypography>
            </Box>
            <Box component="div" sx={rowSx}>
              <CustomTypography sx={{ color: '#b5c7ef' }}>Count</CustomTypography>
              <CustomTypography sx={{ color: item.valueColor }}>{item.value}</CustomTypography>
            </Box>
          </Card>
        ))}
      </Box>
    </Box>
  );
};
